import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { communication___call } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { ActionButtonGroupPresentation } from '../ActionButtonGroup/ActionButtonGroupPresentation.js';
import { HeadlinePresentation } from '../Headline/HeadlinePresentation.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import '../IconLink/IconLinkPresentation.js';
import { ParagraphPresentation } from '../Paragraph/ParagraphPresentation.js';
import { getThemeClass } from '../Theme/ThemePresentation.js';
import { hostClass } from './ContactModule.styles.js';

var defaultProps = {
  /* empty */
};
var ContactModulePresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      children = props.children,
      className = props.className,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      href = props.href,
      phoneNumber = props.phoneNumber,
      phoneText = props.phoneText,
      onClick = props.onClick,
      headline = props.headline,
      headlineAs = props.headlineAs,
      subline = props.subline,
      sublineAs = props.sublineAs,
      htmlAttrs = props.htmlAttrs;
  var linkHref = phoneNumber && "tel:".concat(phoneNumber) || href || undefined;
  var headlineText = phoneText || headline;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, getThemeClass("brand"), true), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-toparea")
  }, (linkHref || onClick) && phoneText && /*#__PURE__*/React.createElement(IconLinkWrapper, {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-phonenumber"), !!phoneText)),
    htmlAttrs: htmlAttrs,
    icon: communication___call,
    look: "left",
    onClick: onClick || function () {
      /* empty */
    },
    href: linkHref,
    noMargin: true
  }, headlineText), (linkHref || onClick) && headline && /*#__PURE__*/React.createElement(ActionPresentation, {
    htmlAttrs: htmlAttrs,
    href: linkHref,
    onClick: onClick || function () {
      /* empty */
    }
  }, /*#__PURE__*/React.createElement(HeadlinePresentation, {
    size: "h4",
    as: headlineAs,
    noMargin: true,
    className: "".concat(hostClass, "-headline"),
    centeredLayout: true
  }, headlineText)), !linkHref && !onClick && headlineText && /*#__PURE__*/React.createElement(HeadlinePresentation, {
    size: "h4",
    as: headlineAs,
    noMargin: true,
    className: "".concat(hostClass, "-headline")
  }, headlineText), /*#__PURE__*/React.createElement(ParagraphPresentation, {
    size: "lead-text",
    as: sublineAs,
    noMargin: true,
    className: "".concat(hostClass, "-subline")
  }, subline)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-actionbuttons")
  }, /*#__PURE__*/React.createElement(ActionButtonGroupPresentation, {
    noMargin: true
  }, children)));
}, defaultProps);

export { ContactModulePresentation, defaultProps };
